module.exports = __webpack_public_path__ + "static/media/map-location-icon.5d0ae81a.svg";